(function(){
  function store(k,v){try{if(v===null)localStorage.removeItem(k);else localStorage.setItem(k,v);return true}catch(e){return false}}
  function read(k){try{return localStorage.getItem(k)}catch(e){return null}}
  document.querySelectorAll('a[href*="return_url="],a[href*="return_to="]').forEach(function(a){
    a.addEventListener('click',function(){store('sp-espace',a.href.indexOf('amb-accueil')>-1?'amb':'rev')});
  });
  var choix=read('sp-espace');
  if(choix&&document.querySelector('.dash')){
    var p=location.pathname;
    var dansAmb=p.indexOf('/pages/amb-')===0;
    var peutAmb=!!document.querySelector('.side-nav a[href="/pages/amb-accueil"]');
    store('sp-espace',null);
    if(choix==='amb'&&!dansAmb&&peutAmb&&(p==='/'||p.indexOf('/account')===0)){location.replace('/pages/amb-accueil');return}
  }
  /* Photo de profil */
  var av=document.querySelector('[data-av]'),file=document.querySelector('[data-av-file]'),edit=document.querySelector('[data-av-edit]');
  if(av&&file){
    var key='sp-av-'+av.getAttribute('data-av');
    var show=function(src){av.innerHTML='';var i=new Image();i.alt='';i.src=src;av.appendChild(i);if(edit)edit.textContent='Changer ma photo'};
    var saved=read(key);if(saved)show(saved);
    var pick=function(){file.click()};
    av.addEventListener('click',pick);if(edit)edit.addEventListener('click',pick);
    file.addEventListener('change',function(){
      var f=file.files&&file.files[0];if(!f)return;
      var r=new FileReader();
      r.onload=function(){
        var img=new Image();
        img.onload=function(){
          var s=320,c=document.createElement('canvas');c.width=s;c.height=s;
          var m=Math.min(img.width,img.height),x=(img.width-m)/2,y=(img.height-m)/2;
          c.getContext('2d').drawImage(img,x,y,m,m,0,0,s,s);
          var url=c.toDataURL('image/jpeg',0.85);
          show(url);store(key,url);
        };
        img.src=r.result;
      };
      r.readAsDataURL(f);
    });
  }
  var side=document.querySelector('.side'),nav=side&&side.querySelector('.side-nav');
  if(side&&nav){
    var cur=nav.querySelector('.is-on');
    var b=document.createElement('button');
    b.type='button';b.className='side-toggle';b.setAttribute('aria-expanded','false');
    b.innerHTML='<span>Menu · '+(cur?cur.textContent.trim():'Navigation')+'</span><i><span></span></i>';
    nav.parentNode.insertBefore(b,nav);
    b.addEventListener('click',function(){var o=side.classList.toggle('is-open');b.setAttribute('aria-expanded',o?'true':'false')});
  }
  var f=document.querySelectorAll('[data-capfilter]');
  f.forEach(function(btn){btn.addEventListener('click',function(){
    var v=btn.getAttribute('data-capfilter');
    f.forEach(function(x){x.classList.toggle('is-on',x===btn)});
    document.querySelectorAll('[data-cap]').forEach(function(c){c.hidden=!(v==='all'||c.getAttribute('data-cap')===v)});
  })});
  document.querySelectorAll('input[name=quantity][min]').forEach(function(i){
    i.addEventListener('change',function(){var m=parseInt(i.min,10)||1;if((parseInt(i.value,10)||0)<m)i.value=m});
  });
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-swap]');if(!t)return;
    var img=t.closest('.pic-wrap').querySelector('.pic img');if(!img)return;
    var on=t.getAttribute('data-on')==='1';
    img.removeAttribute('srcset');img.removeAttribute('sizes');
    img.src=on?t.getAttribute('data-back'):t.getAttribute('data-swap');
    t.setAttribute('data-on',on?'0':'1');
    var s=t.querySelector('span');if(s)s.textContent=on?"L'étui":'Le flacon';
  });
})();